export default {
  columns: {
    offerName: 'Nombre de la oferta',
    type: 'Tipo',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    details: 'Detalles',
    schedule: 'Programación',
    startDate: 'Fecha de inicio',
    images: 'Imagen',
  },
  actions: {
    edit: 'Editar',
    rename: 'Renombrar',
    delete: 'Eliminar',
    set_active: 'Activar',
    set_inactive: 'Desactivar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    activate: 'Reemplazar y activar',
    manage_images: 'Editar imagen',
  },
  toasts: {
    offer_enabled: '{{offer}} es ahora la oferta activa para {{for}}',
    offer_disabled: '{{offer}} establecida como inactiva.',
    update_failed: 'La actualización de la oferta falló.',
    successfully_deleted: 'La oferta se ha eliminado correctamente',
    delete_failed: 'La eliminación de la oferta falló',
  },
  title: 'Gestionar todas las ofertas',
  popups: {
    delete: {
      title: '¿Seguro que desea eliminar esta oferta?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'No se permite reemplazar ofertas principales',
      title: '¿Reemplazar la oferta activa para este período?',
      description:
        'Estás activando {{offer}} el {{weekday}}{{between}}. Esto desactivará la oferta activa actual {{currentOffer}} para el mismo período.',
      between: ', entre {{start}}-{{end}}',
    },
  },
};
